import type { TourStep } from 'types'

export const getUnseenSteps = (
  {
    steps,
  }: {
    steps: TourStep[];
  },
): TourStep[] => (steps.filter(({ status }) => !status))
